import { render, staticRenderFns } from "./DocumentFormDialog.vue?vue&type=template&id=c00b369a&"
import script from "./DocumentFormDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports